import React from 'react';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { useSelector } from "react-redux";
import RTL from "../RTL/RTL";
import "Styles/layouts/_admin-layout.scss";

function SuperLayout(props) {
    const {rtlLayout} = useSelector(state => ({
        rtlLayout: state.settings.rtlLayout
    }))
    const theme = createTheme({
        direction: rtlLayout ? 'rtl' : 'ltr'
    })
    return (
        <RTL>
            <MuiThemeProvider theme={theme}>
                {props.children}
            </MuiThemeProvider>
        </RTL>
    );
}

export default SuperLayout;

